import { EstatusRetoEnum } from './estatus.reto.enum';
import { Reto } from './reto';

export class EstatusRetosEquipo {

  estatus:  EstatusRetoEnum;
  counterback: number;
  counterbackFormat: string;
  reto: Reto;
  avance: number;
  ganador: any;

  constructor() {
    this.estatus = null;
    this.counterback = 0;
    this.counterbackFormat = '';
    this.reto = new Reto;
    this.avance = 0;
  }
}



// WEBPACK FOOTER //
// ./src/dominio/estatus.reto.equipo.ts